import RedeemOutlinedIcon from "@mui/icons-material/RedeemOutlined";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { LedgerLine } from "../UIToolkit/molecules/LedgerLine";
import { BreakSegmentLine } from "./BreakSegmentLine";
import { moneyOrHidden } from "./consts";
import { PaidSegmentView } from "./PaidSegmentView";
import type { WageSegment } from "./wageComposition";

type Props = {
	segment: WageSegment;
	/** Whether this segment's rule lines are unfolded (the panel's composition toggle). */
	compositionOpen: boolean;
	/** The segment's composition region id (named by the fold toggle's `aria-controls`). */
	regionId: string;
	showOwnBase: boolean;
	agencyName: string | null;
	canViewWage: boolean;
	canOpenWageSettings: boolean;
};

/** One segment of the shift: a paid stretch with its composition, a break deduction, or the shift's bonus. */
export const WageSegmentView: FC<Props> = ({ segment, canViewWage, canOpenWageSettings, ...paidProps }) => {
	const { t } = useTranslation();
	switch (segment.type) {
		case "break":
			return (
				<BreakSegmentLine
					row={segment.row}
					rule={segment.rule}
					open={paidProps.compositionOpen}
					regionId={paidProps.regionId}
					canViewWage={canViewWage}
					canOpenWageSettings={canOpenWageSettings}
				/>
			);
		case "bonus":
			return (
				<LedgerLine
					leading={<RedeemOutlinedIcon sx={{ color: "primary.main" }} />}
					label={t("wageBreakdown.bonus")}
					detail={t("wageBreakdown.bonusDetail")}
					amount={moneyOrHidden(segment.wageCents, canViewWage)}
					dataTestId={`wage-breakdown-subtable-row-${segment.row.id}`}
				/>
			);
		case "paid":
			return <PaidSegmentView segment={segment} canViewWage={canViewWage} canOpenWageSettings={canOpenWageSettings} {...paidProps} />;
	}
};
